import { AVAILABILITY_LOCALIZED_STATUS } from 'app/constants/AvailabilityConstants';

const hasStackMap = (stackMapSettings, bibItem) => {
  const { enabled: isEnabledForLibrary, supportedBranches } = stackMapSettings;
  if (!isEnabledForLibrary) {
    return false;
  }

  const { availability, branch, callNumber, collection } = bibItem;

  const { statusType } = availability;
  const isAvailable =
    statusType !== AVAILABILITY_LOCALIZED_STATUS.ON_ORDER && statusType !== AVAILABILITY_LOCALIZED_STATUS.UNAVAILABLE;
  if (!isAvailable) {
    return false;
  }

  const { name: branchName } = branch;
  if (!supportedBranches.includes(branchName)) {
    return false;
  }

  return Boolean(callNumber && collection);
};

export { hasStackMap };
